export type MapChunkOptions = {
  verticalStep: number;
  horizontalStep: number;
};

export const MAP_CHUNK_OPTIONS: MapChunkOptions = { verticalStep: 0.6, horizontalStep: 1.2 };
